import { axiosRMSWrapper } from '../helpers/api'
import { EMethods, RMSRequestUrl } from '../helpers/requests'
import { apiHeaders } from '../../utils/utils'
import { LOCAL_STORAGE_KEYS } from '../../utils/constants'

const authHeaders = () => ({
  ...apiHeaders(localStorage.getItem(LOCAL_STORAGE_KEYS.CONNEXION_TYPE)),
})

export const getReservations = () =>
  axiosRMSWrapper({
    method: EMethods.get,
    url: RMSRequestUrl.reservations,
    headers: authHeaders(),
  })

export const createReservation = (barcodeUid: string, locale: string) =>
  axiosRMSWrapper({
    method: EMethods.post,
    url: RMSRequestUrl.reservations,
    headers: authHeaders(),
    data: { barcodeUid, locale },
  })

export const cancelReservation = (id: number) =>
  axiosRMSWrapper({
    method: EMethods.delete,
    url: RMSRequestUrl.reservations,
    uid: `${id}`,
    headers: authHeaders(),
  })
